// Each sibling room has its own colour; its equipment inherits that colour.
const palette = {
  orange: {primary:'#F28C28',border:'#BD6414',ink:'#75400E'},
  red: {primary:'#E65353',border:'#BA3030',ink:'#7E2424'},
  green: {primary:'#59B85A',border:'#348A39',ink:'#205627'},
  blue: {primary:'#4C97FF',border:'#3373CC',ink:'#204C8A'},
  purple: {primary:'#9966FF',border:'#774DCB',ink:'#50318C'},
  cyan: {primary:'#25B5C4',border:'#16818D',ink:'#125761'},
  brown: {primary:'#A77A53',border:'#795439',ink:'#513825'},
  pink: {primary:'#DC63AB',border:'#AE3A7F',ink:'#792958'},
  yellow: {primary:'#DFC52A',border:'#A48B12',ink:'#695A0D'}
}
const groups = {
  '原材料':'orange',Array:'red',String:'green',Number:'blue',Math:'purple',
  Object:'cyan',JSON:'brown',Boolean:'pink',Date:'yellow',
  declarations:'orange',flow:'blue',operators:'green'
}
function tint(hex,white){
  return '#'+[1,3,5].map(i=>Math.round(parseInt(hex.slice(i,i+2),16)*(1-white)+255*white).toString(16).padStart(2,'0')).join('')
}
export function roomColors(id){
  const color=palette[groups[id]||'orange']
  return {...color,tab:tint(color.primary,.5),card:tint(color.primary,.85),active:tint(color.primary,.66),panel:tint(color.primary,.96)}
}

export function toolColors(id){
  const source={'source.number':'Number','source.string':'String','source.date':'Date','source.array':'Array','source.object':'Object'}
  const keywords={'keyword.const':'declarations','keyword.let':'declarations','keyword.function':'flow','keyword.return':'flow','operator.multiply':'operators'}
  return roomColors(source[id]||keywords[id]||id.split('.')[0])
}
